import React, { useState } from "react";
import "./ContactForm.scss";
import Spinner from "../Spinner/Spinner";
import { sendForm } from "api/form";
// import { sendEmail, sendEmailPure } from "api/email";

interface ContactFormProps {
  pdfUrl?: any;
  pdfUrlCN?: any;
  pdfName?: string[];
  pdfNameCN?: string[];
  language?: "en" | "cn";
}

export function ContactForm({
  pdfUrl,
  pdfUrlCN,
  pdfName,
  pdfNameCN,
  language = "en",
}: ContactFormProps) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [workEmail, setWorkEmail] = useState("");
  const [workPhoneNumber, setWorkPhoneNumber] = useState("");
  const [countryRegion, setCountryRegion] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [agreementChecked, setAgreementChecked] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [response, setResponse] = useState("");

  function resetForm() {
    setFirstName("");
    setLastName("");
    setWorkEmail("");
    setWorkPhoneNumber("");
    setCountryRegion("");
    setJobTitle("");
    setCompanyName("");
  }

  const submitForm = async (e: any) => {
    e.preventDefault();
    if (
      !(
        firstName.trim() &&
        lastName.trim() &&
        workEmail.trim() &&
        workPhoneNumber.trim()
      )
    ) {
      setResponse("Please fill all * fields.");
      return;
    }
    if (!workEmail.trim().replace(" ", "").includes("@")) {
      setResponse("Please input a valid email address.");
      return;
    }
    if (!agreementChecked) {
      setResponse("Please check the agreement checkbox.");
      return;
    }
    setDisableButton(true);
    const response = await sendForm({
      firstName,
      lastName,
      workEmail,
      workPhoneNumber,
      countryRegion,
      jobTitle,
      companyName,
    });
    const emailResponse = 200;
    // const emailResponse = await sendEmailPure({
    //   email: "siqi.su@outlook.com",
    //   // to: "contact@windenergybridge.com",
    //   subject: "UK CfD AR7 Report Download Notification",
    //   content: `
    //     ${firstName} ${lastName} has downloaded the UK CfD AR7 Report.
    //     Work Email: ${workEmail}
    //     Work Phone Number: ${workPhoneNumber}
    //     Country/Region: ${countryRegion || "N/A"}
    //     Job Title: ${jobTitle || "N/A"}
    //     Company Name: ${companyName || "N/A"}
    //     `,
    // });
    if (response === 201 && emailResponse === 200) {
      setResponse("Downloading report...");
      await handleDownload(language);
      localStorage.setItem("download-allowed", "true");
      setResponse("");
      resetForm();
    } else {
      console.log(response, emailResponse);
      setResponse("Failed, please try again");
    }
    setDisableButton(false);
  };

  const handleDownload = async (downloadLanguage: "en" | "cn" = "en") => {
    const urlToFetch =
      downloadLanguage === "cn" && pdfUrlCN ? pdfUrlCN : pdfUrl;
    const res = await fetch(urlToFetch);
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download =
      downloadLanguage === "cn" && pdfNameCN
        ? pdfNameCN.join("-") + ".pdf"
        : pdfName
        ? pdfName.join("-") + ".pdf"
        : "report.pdf";
    a.click();
    window.URL.revokeObjectURL(url);
  };
  return (
    <div className="about-contact-us" id="contact-us">
      <form
        className="about-contact-us-form"
        onSubmit={submitForm}
        onClick={() => {
          setResponse("");
        }}
      >
        <div className="flex flex-col mobile:flex-row even">
          <FormItem
            label="First Name*"
            placeholder="First Name"
            value={firstName}
            set={setFirstName}
          />
          <FormItem
            label="Last Name*"
            placeholder="Last Name"
            value={lastName}
            set={setLastName}
          />
        </div>
        <div className="flex flex-col mobile:flex-row uneven">
          <FormItem
            label="Country/Region"
            placeholder="Your country/region"
            value={countryRegion}
            set={setCountryRegion}
          />
          <FormItem
            label="Company Name"
            placeholder="Your company"
            value={companyName}
            set={setCompanyName}
          />
          <FormItem
            label="Job Title"
            placeholder="Your position"
            value={jobTitle}
            set={setJobTitle}
          />
        </div>
        <FormItem
          label="Work Email*"
          placeholder="your@email.com"
          value={workEmail}
          set={setWorkEmail}
          type="email"
        />
        <FormItem
          label="Work Phone Number*"
          placeholder="Your phone number"
          value={workPhoneNumber}
          set={setWorkPhoneNumber}
          type="tel"
        />
        <label className="flex flex-row items-start gap-4">
          <input
            type="checkbox"
            className="mt-3"
            checked={agreementChecked}
            onChange={(e) => setAgreementChecked(e.target.checked)}
          />
          <p style={{ margin: "0" }}>
            By ticking this box, I understand that I will receive ongoing
            insights from WeBridge by email or phone. I understand that WeBridge
            will ask for personal information, including my email address and
            phone number. Read more in our privacy policy.*
          </p>
        </label>
        <div className="form-item button mt-10">
          <button
            type="submit"
            disabled={disableButton}
            style={{ opacity: disableButton ? "0.7" : "1" }}
          >
            {disableButton ? (
              <Spinner />
            ) : (
              <span>
                {language === "cn"
                  ? "提交并下载中文报告"
                  : "Submit and Download Report"}
              </span>
            )}
          </button>
        </div>
        <p>{response}</p>
      </form>
    </div>
  );
}

function FormItem(props: any) {
  return (
    <div className="form-item">
      <label>
        <span>{props.label}</span>
        <input
          className="txt"
          type={props.type || "text"}
          placeholder={props.placeholder}
          value={props.value}
          onChange={(e) => {
            props.set(e.target.value);
          }}
        />
      </label>
    </div>
  );
}
